export const interceptorNames = {
    auth: 'authInterceptor',
    version: 'versionInterceptor',
    demo: 'demoInterceptor',
    iapRedirect: 'iapRedirectInterceptor',
    backendVersion: 'backendVersionInterceptor',
    totalCount: 'totalCountInterceptor',
    unauthorized: 'unauthorizedInterceptor',
    userAccessNotAllowed: 'userAccessNotAllowedInterceptor',
} as const satisfies Readonly<Record<string, string>>;

export type InterceptorName = (typeof interceptorNames)[keyof typeof interceptorNames];
